import { SegmentedControl, Select, SimpleGrid, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { SectionCard } from '../layout/SectionCard'

// `withFormat: false` when the page shows the format switcher above the preview (AD-209).
export function TemplateSetup({ manifest, schema, presets, configuration, updateValue, withFormat = true }) {
  const { t } = useTranslation()
  if (manifest?.packageContractVersion !== 'studio-editor-v2/package-v2') return null
  if (schema?.ui?.setup === 'grouped') return null
  const formats = manifest.formats || []
  const presetReferences = (manifest.presets || []).filter((entry) => (
    !presets?.[entry.id]?.formatId || presets[entry.id].formatId === configuration.format.id
  ))
  const formatControl = formats.length <= 4 ? (
    <SegmentedControl
      fullWidth
      size="xs"
      value={configuration.format.id}
      data={formats.map((format) => ({ value: format.id, label: format.label }))}
      onChange={(value) => updateValue('format.id', value)}
    />
  ) : (
    <Select
      size="sm"
      label={t('editorV2.shell.adFormat')}
      allowDeselect={false}
      value={configuration.format.id}
      data={formats.map((format) => ({ value: format.id, label: format.label }))}
      onChange={(value) => updateValue('format.id', value)}
    />
  )

  if (!withFormat && !presetReferences.length) return null

  return (
    <SectionCard title={t('editorV2.shell.templateSetup.title')} description={t('editorV2.shell.templateSetup.description')}>
      <SimpleGrid cols={{ base: 1, sm: presetReferences.length && withFormat ? 2 : 1 }} spacing="sm">
        {withFormat && (
          <Stack gap={5}>
            {formats.length <= 4 && <Text size="sm" fw={500}>{t('editorV2.shell.adFormat')}</Text>}
            {formatControl}
          </Stack>
        )}
        {presetReferences.length > 0 && (
          <Select
            size="sm"
            label={t('editorV2.shell.templateSetup.preset')}
            description={t('editorV2.shell.templateSetup.presetDescription')}
            allowDeselect={false}
            value={configuration.presetId}
            data={presetReferences.map((entry) => ({ value: entry.id, label: entry.label }))}
            onChange={(value) => updateValue('presetId', value)}
          />
        )}
      </SimpleGrid>
    </SectionCard>
  )
}
/* Manifest-driven template and format setup. */
